/**
 * @module Utilities/Auth
 * @desc Auth helper funtions
 */

/**
 * Checks if has an access token from url hash
 */
export function hasAccessTokenFromUrl() {
  const { hash } = window.location;

  return !!hash;
}
